import { render, staticRenderFns } from "./FormTransferencia.vue?vue&type=template&id=30b912e9&scoped=true&"
import script from "./FormTransferencia.vue?vue&type=script&lang=js&"
export * from "./FormTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./FormTransferencia.vue?vue&type=style&index=0&id=30b912e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b912e9",
  null
  
)

export default component.exports